import type {
  Questionnaire,
  QuestionnaireFormType,
  QuestionnaireQuestion,
  QuestionnaireSchema,
  SaveQuestionnaireRequest,
  UpdateQuestionnaireDraftRequest,
} from '../../../infrastructure/QuestionnaireClient';
import { createQuestionId, createSurveyUuid } from '../../questionnaire/utils/questionnaireIds';
import { questionTypeUsesOptions } from '../../questionnaire/utils/questionTypes';

export const createBlankQuiz = (): QuestionnaireQuestion[] => [
  {
    questionId: createQuestionId(),
    type: 'single_select',
    label: 'What is your skin type?',
    options: [
      { value: 'dry', label: 'Dry' },
      { value: 'oily', label: 'Oily' },
      { value: 'combination', label: 'Combination' },
      { value: 'sensitive', label: 'Sensitive' },
      { value: 'normal', label: 'Normal' },
    ],
  },
];

export const ensureQuizIds = (quiz: QuestionnaireQuestion[]): QuestionnaireQuestion[] =>
  quiz.map((question) => {
    const questionWithId = {
      ...question,
      questionId: question.questionId || createQuestionId(),
    };

    if (!questionTypeUsesOptions(questionWithId.type)) {
      const questionWithoutOptions: QuestionnaireQuestion = { ...questionWithId };
      delete questionWithoutOptions.options;
      return questionWithoutOptions;
    }

    return {
      ...questionWithId,
      options: questionWithId.options ?? [],
    };
  });

export const getSurveySchema = (survey: Questionnaire | null): QuestionnaireSchema => ({
  questions: ensureQuizIds(survey?.latestVersion?.schema.questions ?? createBlankQuiz()),
});

export const createNewSurveyForm = () => ({
  title: '',
  surveyUuid: createSurveyUuid(),
  formType: 'survey' as QuestionnaireFormType,
});

export const createSurveySaveRequest = (
  form: ReturnType<typeof createNewSurveyForm>,
  schema: QuestionnaireSchema,
): SaveQuestionnaireRequest => ({
  surveyUuid: form.surveyUuid || createSurveyUuid(),
  title: form.title,
  formType: form.formType,
  schema: { questions: ensureQuizIds(schema.questions) },
});

export const createSurveyDeployRequest = (
  form: Omit<ReturnType<typeof createNewSurveyForm>, 'surveyUuid'> | ReturnType<typeof createNewSurveyForm>,
  schema: QuestionnaireSchema,
): UpdateQuestionnaireDraftRequest => ({
  title: form.title,
  formType: form.formType,
  schema: { questions: ensureQuizIds(schema.questions) },
});
